module.exports = __webpack_public_path__ + "static/media/lobbyscreen.322177b0.png";